import React from 'react';
import { Wrench, Settings, Disc, Zap, Move, Droplet } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { mockServices } from '../mock';

const iconMap = {
  wrench: Wrench,
  settings: Settings,
  disc: Disc,
  zap: Zap,
  move: Move,
  droplet: Droplet
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Comprehensive German Car Services
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            From routine maintenance to complex repairs, we offer complete automotive solutions for your German vehicle.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="bg-white border-gray-200 hover:border-red-600 transition-all duration-300 group overflow-hidden shadow-sm"
              >
                <CardHeader>
                  <div className="flex items-start space-x-4">
                    <div className="bg-red-600/20 p-3 rounded-lg group-hover:bg-red-600 transition-colors duration-300">
                      <IconComponent className="w-6 h-6 text-red-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-gray-900 mb-2 group-hover:text-red-600 transition-colors duration-300">
                        {service.title}
                      </CardTitle>
                      <CardDescription className="text-gray-600">
                        {service.description}
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Why Choose Our Services */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Why Choose Our Services?
          </h3>
          <p className="text-white/90 text-lg mb-8 max-w-3xl mx-auto">
            We use only genuine or OEM-equivalent parts, advanced diagnostic tools, and follow manufacturer specifications to ensure your German vehicle receives the care it deserves.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-bold text-white mb-2">90 Days</div>
              <div className="text-white/90">Warranty Coverage</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-bold text-white mb-2">Same Day</div>
              <div className="text-white/90">Service Available</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-white/90">Satisfaction Guarantee</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
